/* Swissöra premium — homepage FAQ injection.
   Wall of Love + reviews now live in partials.js. FAQ here: 7 Q/A + JSON-LD.
   "Suisse" = évocatif only ("inspiré par l'exigence suisse"), jamais claim factuel d'origine. */
(function () {
  'use strict';

  var FAQ = [
    { q: "Comment fonctionne SwissLash ?", a: "SwissLash nourrit les follicules des cils pour stimuler leur croissance naturelle et renforcer leur structure — des cils plus longs et plus denses avec une utilisation régulière." },
    { q: "Quand verrai-je les résultats ?", a: "Chaque personne est différente, mais la plupart des utilisatrices observent des résultats visibles dès 3 semaines d'usage quotidien, et un effet maximal vers 6 à 8 semaines." },
    { q: "SwissLash contient-il des hormones ou des prostaglandines ?", a: "Non. La formule est sans hormones et sans prostaglandines — pas de risque de cernes ni de changement de couleur des yeux. C'est notre engagement clean & safe." },
    { q: "Convient-il aux yeux sensibles ou aux porteuses de lentilles ?", a: "Oui. La formule est sans parfum ajouté et testée sous contrôle dermatologique. Elle convient aux yeux sensibles et aux porteuses de lentilles. En cas de doute, faites un test sur une petite zone." },
    { q: "Compatible avec des extensions de cils ?", a: "Oui. SwissLash s'applique sur la base des cils naturels et reste compatible avec les extensions. Il renforce vos cils naturels sous les extensions." },
    { q: "Comment l'appliquer ?", a: "La règle 1-1-1 : 1 application par jour · 1 trait fin · 1 fois le soir, sur la base des cils propres et démaquillés. N'appliquez jamais dans l'œil." },
    { q: "Le produit est-il sûr et éthique ?", a: "100% vegan et cruelty-free, formulé dans le respect de standards d'exigence inspirés par la précision suisse. Déconseillé pendant la grossesse et l'allaitement." }
  ];

  var fl = document.getElementById('faqList');
  if (fl) {
    var cross = (window.SwissoraCross ? window.SwissoraCross() : '');
    FAQ.forEach(function (f) {
      var item = document.createElement('div');
      item.className = 'faq__item';
      item.innerHTML = '<button class="faq__q">' + cross + f.q +
        '</button><div class="faq__a"><p>' + f.a + '</p></div>';
      var btn = item.querySelector('.faq__q');
      var ans = item.querySelector('.faq__a');
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('open');
        ans.style.maxHeight = open ? ans.scrollHeight + 'px' : '0';
      });
      fl.appendChild(item);
    });

    /* FAQ JSON-LD (SEO rich snippets) */
    var ld = { "@context": "https://schema.org", "@type": "FAQPage", "mainEntity": FAQ.map(function (f) {
      return { "@type": "Question", "name": f.q, "acceptedAnswer": { "@type": "Answer", "text": f.a } };
    }) };
    var s = document.createElement('script');
    s.type = 'application/ld+json';
    s.textContent = JSON.stringify(ld);
    document.head.appendChild(s);
  }
})();
